exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.welcome-modal .modal-dialog{width:500px;top:25%}}@media (max-width:768px){.welcome-modal .modal-dialog{width:280px;left:3%}}.onboarding h2{color:#545454;font-size:30px;line-height:1.2;margin-top:15px}.onboarding h3{color:#545454;font-size:16px;line-height:1.4;max-width:370px;margin:20px auto 0}.onboarding a.onboard-button{display:block;border-radius:2px;border:2px solid #3ec19d;font-size:16px;color:#fff;font-weight:600;width:300px!important;background:#3ec19d;line-height:1;padding:10px 0;margin:20px auto;text-decoration:none}.onboard-item a.onboard-skip,.onboarding a.onboard-skip{display:block;margin:0 auto;font-size:14px;color:#545454;line-height:1;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/dashboard/forms/welcomeModal.css
// module id = 744
// module chunks = 0